const getVerifyStatusText = status => (status === 'approved' || status === 'not_required' ? 'Verified' : 'Not verified');

export default getVerifyStatusText;
